<template>
    <tbody v-if="index <= 5 || (index > 5 && showOlder)">
    <tr :class="['period-budget', row.is_current ? 'text-bold' : '']" @click="toggle" style="cursor:pointer">
        <td>
            {{ row.name }}
            <i :class="[ 'glyphicon', isOpen ? 'glyphicon-collapse-down' : 'glyphicon-collapse-up', 'is-aligned-right' ]"></i>
        </td>
        <td>
            <span v-if="!isNaN(row.budget)">{{ money(row.budget) }}</span>
            <span v-else-if="row.budget">{{ row.budget }}</span>
        </td>
        <td><span v-if="row.value">{{ money(row.value) }}</span></td>
        <td @click.stop="">
            <a href="#" :class="['dashed-link', !!row.agency_name ? '' : 'add-agency']" @click.prevent="openAgencyDialog">
                {{ !!row.agency_name ? row.agency_name : 'Add' }}
            </a>
        </td>
        <td @click.stop="">
            <a href="#" class="dashed-link" @click.prevent="openNetInvoiceDialog">{{ row.net_invoice }}</a>
            <i v-if="row.payments_count > 0" class="far fa-credit-card" aria-hidden="true" title="Payments assigned"></i>
            <i v-if="row.is_net_invoice_manual" class="fas fa-hand-holding-usd" aria-hidden="true" title="NET Invoice inputted manually"></i>
        </td>
        <td @click.stop="">
            <a href="#" class="dashed-link" @click.prevent="openPaymentStatusDialog">{{ row.paid_status_text }}</a>
        </td>
    </tr>

    <tr v-if="isOpen">
        <td colspan="8" v-loading="!isLoaded">
            <BtreePaymentInput :transactions="btreeTransactions"
                               @unlinked="btreePaymentUnlinked"></BtreePaymentInput>
            <StripePaymentInput :charges="stripeCharges"
                                @unlinked="stripePaymentUnlinked"></StripePaymentInput>
            <PaymentsNotesInput :notes="notes"
                                :budget-period-id="row.id"
                                @noted="notesChanged"></PaymentsNotesInput>
        </td>
    </tr>
    </tbody>
</template>

<script>
import BtreePaymentInput from './../../RevenueBraintree/vue/payment-input';
import StripePaymentInput from './../../RevenueStripe/vue/payment-input';
import PaymentsNotesInput from './notes-input';

export default {
    components: { BtreePaymentInput, StripePaymentInput, PaymentsNotesInput },
    props: {
        row: { type: Object, required: true },
        index: { type: [String, Number], required: true },
        showOlder: { type: Boolean, default: true },
    },
    data() {
        return {
            isOpen: false,
            isLoaded: false,
            btreeTransactions: [],
            stripeCharges: [],
            notes: [],
        };
    },
    mounted() {},
    methods: {
        toggle() {
            if (!this.isOpen && !this.isLoaded) this.loadInnerData();
            this.isOpen = !this.isOpen;
        },
        btreePaymentUnlinked(newTransactions) {
            this.btreeTransactions = newTransactions;
        },
        stripePaymentUnlinked(newCharges) {
            this.stripeCharges = newCharges;
        },
        notesChanged(newNotes) {
            this.notes = newNotes;
        },
        openAgencyDialog() {
            this.$emit('open-agency-dialog', {
                period: this.row.id,
                value: this.row.agency_id,
                employer: this.row.employer_id,
                index: this.index,
            });
        },
        openNetInvoiceDialog() {
            this.$emit('open-net-invoice-dialog', {
                period: this.row.id,
                value: this.row.net_invoice,
                employer: this.row.employer_id,
                index: this.index,
            });
        },
        openPaymentStatusDialog() {
            let value = 'Assumed';
            if (this.row.paid_status_text.includes('Paid')) value = 'Paid';
            else if (this.row.paid_status_text.includes('Invoiced')) value = 'Invoiced';

            this.$emit('open-payment-status-dialog', {
                period: this.row.id,
                value: value,
                employer: this.row.employer_id,
                index: this.index,
            });
        },
        loadInnerData() {
            this.isLoaded = false;
            return axios.get(url(`admin/payments/get-data-inner`), {
                params: {
                    period_id: this.row.id,
                },
            }).then(response => {
                this.btreeTransactions = response.data.btree_transactions;
                this.stripeCharges = response.data.stripe_charges;
                this.notes = response.data.notes;

                this.isLoaded = true;
            });
        },
    },
};
</script>

<style scoped>
.text-bold {
    font-weight: bold;
}
.add-agency {
    color: #dd1144;
    font-style: italic;
}
a.dashed-link {
    border-bottom: 1px dashed #0088cc;
    text-decoration: none;
}
</style>
